module.exports = __webpack_public_path__ + "static/media/CPL.f617785d.jpg";